export default __webpack_public_path__ + "static/media/auth_validation_undraw.6e05b02c.svg";